import { useEffect } from "react";
import Lenis from "lenis";

import Nav from "@/components/Nav";
import RhinoMascot from "@/components/RhinoMascot";
import HeroBrand from "@/components/sections/HeroBrand";
import AboutBrand from "@/components/sections/AboutBrand";
import HcaspHero from "@/components/sections/HcaspHero";
import AboutHcasp from "@/components/sections/AboutHcasp";
import Highlights from "@/components/sections/Highlights";
import Audience from "@/components/sections/Audience";
import ExamInfo from "@/components/sections/ExamInfo";
import ExamWeights from "@/components/sections/ExamWeights";
import Curriculum from "@/components/sections/Curriculum";
import Pricing from "@/components/sections/Pricing";
import Footer from "@/components/sections/Footer";
import TrainingsTeaser from "@/components/sections/TrainingsTeaser";
import CouponTeaser from "@/components/sections/CouponTeaser";
import WebinarTeaser from "@/components/sections/WebinarTeaser";

const Landing = () => {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;

    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };

    rafId = requestAnimationFrame(raf);

    window.__lenis = lenis;

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    const handleHashScroll = () => {
      const hash = window.location.hash?.replace("#", "");

      if (!hash) return;

      setTimeout(() => {
        const el = document.getElementById(hash);

        if (!el) return;

        if (window.__lenis) {
          window.__lenis.scrollTo(el, {
            offset: -80,
            duration: 1.2,
          });
        } else {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 300);
    };

    handleHashScroll();

    window.addEventListener("hashchange", handleHashScroll);

    return () => {
      window.removeEventListener("hashchange", handleHashScroll);
    };
  }, []);

  return (
    <div className="relative bg-[#07070c] text-white font-body">
      <Nav />
      <RhinoMascot />

      <main>
        <HeroBrand />
        <AboutBrand />

        <div className="relative">
          <div className="sticky top-0 h-screen z-0 overflow-hidden">
            <HcaspHero />
          </div>

          <div className="relative z-10 bg-[#07070c]">
            <AboutHcasp />
            <Highlights />
            {/* <CouponTeaser /> */}
            <Audience />
            <ExamInfo />
            <ExamWeights />
            {/* <WebinarTeaser /> */}
            <Curriculum />
            {/* <TrainingsTeaser /> */}
            <Pricing />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Landing;
